import { useEffect, useRef, useState } from 'react';
import './UpdatePlace.sass';

import Footer from '../Footer/Footer';
import EditFloorPlanEquipment from './EditFloorPlanEquipment/EditFloorPlanEquipment';
import Header from '../Header/Header';

import { faArrowUpFromBracket, faFloppyDisk } from '@fortawesome/free-solid-svg-icons';
import { uid } from 'uid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import imageCompression from "browser-image-compression";
import { collection, doc, getDoc, onSnapshot, query, setDoc } from 'firebase/firestore';
import { useNavigate, useParams } from 'react-router-dom';
import { db } from '../firebase/firebase';

const UpdatePlace = () => {
    const layoutImgRef = useRef();
    const floorPlanRef = useRef();
    const nameRef = useRef();

    const [placeTitle, setPlaceTitle] = useState('');

    const [folderList, setFolderList] = useState([]);
    const [folderSelectLoaded, setFolderSelectLoaded] = useState(false);
    const folderSelectionRef = useRef('');

    const [originalFolder, setOriginalFolder] = useState();
    const [originalFolderID, setOriginalFolderID] = useState();

    const navigate = useNavigate();

    const [imgSrc, setImgSrc] = useState('');
    const [imgName, setImgName] = useState('');
    const [imgBase64, setImgBase64] = useState('');

    const [saveDisabled, setSaveDisabled] = useState(true);
    const [ableToCreate, setAbleToCreate] = useState(true);
    const [uploadFail, setUploadFail] = useState(false); 

    const [xCoord, setXCoord] = useState(0);
    const [yCoord, setYCoord] = useState(0);
    const [isCtrlPressed, setIsCtrlPressed] = useState(false);

    const [equipmentPlacements, setEquipmentPlacements] = useState([]);

    const [loadedEquipments, setLoadedEquipments] = useState(false);

    let id = useParams().id;

    useEffect(() => {
        let data;

        const fetchData = async () => {
            // console.log(id);

            const q = query(doc(db, 'places', id));
                        
            const querySnapshot = await getDoc(doc(db, 'places', id));
            data = querySnapshot.data(); 
            setImgSrc(data.floorPlanImgSrc);
            setImgName(data.floorPlanImgName);
            setPlaceTitle(data.name);

            const updatedEquipments = data.equipments.map(equipment => ({
                ...equipment,
                showOptions: false, // Nur einmalig setzen
            }));
    
            setEquipmentPlacements(updatedEquipments);
        }

        fetchData();

        

        setTimeout(() => setFolderSelectLoaded(true), 1000)

        const handleKeyDown = (event) => {
            const isCreateNewShortcut = event.ctrlKey || event.metaKey;

            if(isCreateNewShortcut) {
                setIsCtrlPressed(true);
            }
        };

        const handleKeyUp = (event) => {
            if (event.key === 'Control') {
              setIsCtrlPressed(false);
            }
        };
    
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);

        const unsubscribeFolders = onSnapshot(collection(db, "place-folders"), (snapshot) => {
            const placeFoldersData = snapshot.docs.map(el => ({ id: el.id, ...el.data() }));
            setFolderList(placeFoldersData);
            
            let currentFolder;

            placeFoldersData.map(folder => {
                console.log('folder: ' + folder);
                if(folder.places.includes(id)) {
                    currentFolder = folder;
                }
            });

            console.log('currentFolder: ', currentFolder)

                
            setOriginalFolder(currentFolder);
        });


        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
            unsubscribeFolders();

        };
    }, []);

        

    useEffect(() => {
        if (equipmentPlacements.length > 0) {
            console.log('Equipment Placements geladen:', equipmentPlacements);
            setLoadedEquipments(true);
        }
    }, [equipmentPlacements]);

    const equipmentClickEvent = (e) => {
        let el;

        let tempPlaces = [...equipmentPlacements];

        tempPlaces.map(equipment => {
            equipment.showOptions = false;
            if(e.target.classList[0] == equipment.id) {
                console.log(equipment);
                equipment.showOptions = true;
                setXCoord(equipment.x * 100);
                setYCoord(equipment.y * 100);
            }
        });

        console.log('test');
        console.log(equipmentPlacements);
    
        setEquipmentPlacements(tempPlaces);
    }

    const handleFileUpload = async () => {
        const file = layoutImgRef.current.files[0];

        if(file) {
            if(file.name.split('.').pop() == 'png') {
                setUploadFail(false);
                const reader = new FileReader();

                const options = {
                    maxSizeMB: 100,
                    maxWidthOrHeight: 800,
                    useWebWorker: true
                };
                const compressedImg = await imageCompression(file, options);
                reader.readAsDataURL(file);

                reader.onloadend = () => {
                    setImgSrc(reader.result);
                    setImgName(file.name);
                    setUploadFail(false);
                    setSaveDisabled(false);
                }
            } else {
                setUploadFail(true);
                setSaveDisabled(true);
            }
        } else {
            setUploadFail(true);
        }        
    }

    const handleEquipmentDeletion = (data) => {
        console.log(data);

        setEquipmentPlacements(equipmentPlacements.filter(equipment => equipment !== data));
        setAbleToCreate(true);
    }

    const handleNewEquipmentPlacement = (event) => {
        if (imgSrc !== '' && isCtrlPressed && ableToCreate) {
            const imgElement = floorPlanRef.current;
            const rect = imgElement.getBoundingClientRect();

            // Berechnung der relativen Koordinaten
            const relativeX = (event.clientX - rect.left) / rect.width;
            const relativeY = (event.clientY - rect.top) / rect.height;

            // Sicherstellen, dass die Koordinaten innerhalb des Bildes liegen
            if (relativeX >= 0 && relativeX <= 1 && relativeY >= 0 && relativeY <= 1) {
                setXCoord(Math.round(relativeX * 100)); // Optional: Für Anzeige in Prozent
                setYCoord(Math.round(relativeY * 100)); // Optional: Für Anzeige in Prozent
                setAbleToCreate(false);

                // Speichere die relativen Koordinaten
                setEquipmentPlacements(equipmentPlacements => [
                    ...equipmentPlacements,
                    {
                        id: uid(12),
                        x: relativeX, // Speichere relative X-Koordinate
                        y: relativeY, // Speichere relative Y-Koordinate
                        showOptions: true,
                        data: {
                            selectedEquipment: '',
                            category: 0,
                            color: '#5672E4'
                        }
                    }
                ]);
            }
        }
    }

    const saveNewEquipment = () => {
        const equipment = {
            equipments: equipmentPlacements,
            floorPlanImgSrc: imgSrc,
            floorPlanImgName: imgName,
            name: placeTitle,
            nameId: id
        }

        const folder = folderList.find(val => val.id == folderSelectionRef.current.value);

        const newFolderData = {
            name: folder.name,
            id: folder.id,
            places: folder.places.includes(id) ? folder.places : [...folder.places, id]
        }

        let oldFolderData = {
            name: originalFolder.name,
            id: originalFolder.id,
            places: []
        }

        originalFolder.places.map(place => {
            if(place != id) {
                oldFolderData.places.push(place);
            }
        });

        console.log('Comparison Old Places vs. New Places:');
        console.log(originalFolder.places);
        console.log(oldFolderData.places);

        if(originalFolder.id == newFolderData.id) {
            console.log('Keine Änderung');
        } else {
            console.log('Neue Ordnerauswahl: ' + originalFolder.name + ' -> ' + newFolderData.name);
        }

        console.log('Original Folder: ', originalFolder);

        setDoc(doc(db, 'place-folders', folder.id), newFolderData);

        if(folderSelectionRef.current.value != originalFolder.id) {
            
            setDoc(doc(db, 'place-folders', originalFolder.id), oldFolderData);
        } else {
            console.log('TEST');
        }
        setDoc(doc(db, 'places', id), equipment).then(navigate('/'));

        console.log(equipmentPlacements);
    }

    const updateEquipmentColor = (id, newColor) => {
        const updated = equipmentPlacements.map(equipment =>
            equipment.id === id
                ? { ...equipment, data: { ...equipment.data, color: newColor } }
                : equipment
        );
        setEquipmentPlacements(updated);
    };


    return (
        <div className="UpdatePlace">
            <Header pageName={<input value={placeTitle} onChange={e => setPlaceTitle(e.currentTarget.value)} className='new-place-name' placeholder="Party-Ort" />} />

            <div className="information-for-selected">
                <div className="left">
                    {imgSrc != '' ? <div className="box">
                        <div className="row">
                            <p className='val'>Bild</p>
                        </div>
                        <div className="row">
                            <div className="row-container">
                                <p>Grundriss</p>
                                <p className='val'>{imgName.slice(0, 30)}{imgName.length > 30 ? '...' : null}</p>
                            </div>
                        </div>
                    </div> : null}

                    <div className="box">
                        <div className="row">
                            <p className='val'>Koordinaten (im Grundriss)</p>
                        </div>
                        <div className="row">
                            <div className="row-container">
                                <p>x</p>
                                <p className='val'>{Math.round(xCoord)}</p>
                            </div>
                            <div className="row-container">
                                <p>y</p>
                                <p className='val'>{Math.round(yCoord)}</p>
                            </div>
                        </div>
                    </div>

                    {folderSelectLoaded && imgSrc != '' ? <div className="box">
                        <div className="row"><p className="val">Ordner</p></div>
                        <select ref={folderSelectionRef} className='folder-select'>
                            {folderList.map(folder => {
                                return <option selected={originalFolder.id == folder.id ? true : false} key={folder.id} value={folder.id}>{folder.name}</option>
                            })}
                        </select>
                    </div> : null}
                </div>

                {imgSrc != '' ? <div className="box">
                    <div className="row"><p className="val">Fertig?</p></div>
                    <button onClick={saveNewEquipment} className="save-floor-plan"><FontAwesomeIcon icon={faFloppyDisk} />  Speichern</button>
                </div> : null}
            </div>

            <div className="bottom-container">
                <div className='layout'>
                    {imgSrc == '' ? <div className="img-upload">
                        <label htmlFor="img-upload"><FontAwesomeIcon icon={faArrowUpFromBracket} /><p>Bild einfügen</p></label>
                        {uploadFail ? <p className='upload-fail-text'>Die hochgeladene Datei hat keinen unterstützen Dateitypen (.png)</p> : null}
                        <input ref={layoutImgRef} onChange={handleFileUpload} type="file" name="" id="img-upload" />
                    </div> : <div>   
                        <img ref={floorPlanRef} src={imgSrc} className="floor-plan-img"  />
                        <div onClick={handleNewEquipmentPlacement} className={isCtrlPressed ? "floor-plan-edit-layer creation-mode" : "floor-plan-edit-layer"} style={{
                            width: `${floorPlanRef.current ? floorPlanRef.current.getBoundingClientRect().width : 0}px`,
                            height: `${floorPlanRef.current ? floorPlanRef.current.getBoundingClientRect().height : 100}px`,
                            background: 'transparent',
                            position: 'absolute',
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 200
                        }}>                    
                            {loadedEquipments ? equipmentPlacements.map(equipment => {
                                const rect = floorPlanRef.current.getBoundingClientRect(); // Aktuelle Größe des Bildes
                                const absoluteX = equipment.x * rect.width; // Berechne absolute X-Koordinate
                                const absoluteY = equipment.y * rect.height; // Berechne absolute Y-Koordinate

                                return (
                                    <div
                                        key={equipment.id}
                                        className={equipment.id}
                                        onClick={equipmentClickEvent}
                                        style={{
                                            position: 'absolute',
                                            height: '3rem',
                                            width: '3rem',
                                            borderRadius: '100%',
                                            background: equipment.data.color,
                                            left: absoluteX - 24, // Zentriere den Kreis
                                            top: absoluteY - 24, // Zentriere den Kreis
                                            zIndex: 120,
                                            cursor: 'pointer',
                                            boxShadow: `0 0 1px 0 ${equipment.data.color} inset, 0 0 1px 0 ${equipment.data.color}`,
                                        }}
                                    ></div>
                                );
                            }) : null}
                        </div>
                    </div>}

                </div>

                <div className="layout-item-select">
                    {loadedEquipments ? <div>
                        {equipmentPlacements.map(equipment => <EditFloorPlanEquipment updateEquipmentColor={updateEquipmentColor} handleEquipmentDeletion={handleEquipmentDeletion} data={equipment} setAbleToCreate={setAbleToCreate} />)}    
                    </div> : <div>
                        <h1>Auswahl</h1>

                        <p>Aktuell ist kein Equipment ausgewählt.</p>   
                    </div>}
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default UpdatePlace;